import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { SvgIconComponent } from '@woolworthsnz/styleguide';

@Component({
	selector: 'search-no-results',
	templateUrl: './no-results.component.html',
	styleUrls: ['./no-results.component.scss'],
	standalone: true,
	imports: [SvgIconComponent],
})
export class NoResultsComponent implements OnInit {
	keyword: string;
	queryParams$ = this.route.queryParams.pipe(takeUntilDestroyed());
	constructor(private route: ActivatedRoute, private cdr: ChangeDetectorRef) {}

	ngOnInit(): void {
		this.queryParams$.subscribe(() => {
			this.keyword = this.route.snapshot.queryParamMap.get('search') || '';
			this.cdr.markForCheck();
		});
	}
}
